export var lineStyles = {
    display: "block",
    color: "textSecondary",
    fontSize: "xxs",
    lineHeight: "1.4em",
    whiteSpace: "nowrap",
    fontFamily: "Helvetica, Arial, sans-serif",
};
export var lineStylesListView = {
    display: "block",
    color: "textSecondary",
    fontSize: "xxs",
    lineHeight: "1.2em",
    whiteSpace: "nowrap",
    fontFamily: "Helvetica, Arial, sans-serif",
};
export var footerStyles = {
    backgroundColor: "neutral.lighter",
    position: "absolute",
    bottom: 0,
    width: "100%",
    py: "xs-2",
};
export var footerStylesListView = {
    backgroundColor: "neutral.lighter",
    pl: "lg",
    py: "xs-2",
    margin: "auto",
};
//# sourceMappingURL=constants.js.map